import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import Contact from "./pages/contact";
import PageClinic from "./pages/Clinic/page";
import PageCT from "./pages/Center/page";
import PageAbout from "./pages/About/page";
import PageAbout2 from "./pages/About/page2";
import PageAbout3 from "./pages/About/page3";
import PageAbout4 from "./pages/About/page4";
import Detail from "./pages/detail";
import PageSurgery from "./pages/Surgery/page";
import PageNews from "./pages/New/page";
import PageOther from "./pages/OtherPage/page";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/pages/detail/:id",
    element: <Detail />,
  },

  // Contact
  {
    path: "/contact",
    element: <Contact />,
  },

  // คลินิกพิเศษ
  {
    path: "/clinic/page/:id",
    element: <PageClinic />,
  },

  // ศัลยกรรม
  {
    path: "/surgery/page/:id",
    element: <PageSurgery />,
  },
  // Center
  {
    path: "/center/page/:id",
    element: <PageCT />,
  },

  // Other
  {
    path: "/other/page/:id",
    element: <PageOther />,
  },

  // News
  {
    path: "/news/page/:id",
    element: <PageNews />,
  },

  // About
  {
    path: "/pages/about",
    element: <PageAbout />,
  },
  {
    path: "/pages/about2",
    element: <PageAbout2 />,
  },
  {
    path: "/pages/about3",
    element: <PageAbout3 />,
  },
  {
    path: "/pages/about4",
    element: <PageAbout4 />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);

reportWebVitals();
